import { render } from "./DPMainCategory.vue?vue&type=template&id=978375fa&ts=true"
import script from "./DPMainCategory.vue?vue&type=script&lang=ts"
export * from "./DPMainCategory.vue?vue&type=script&lang=ts"

import "./DPMainCategory.vue?vue&type=style&index=0&id=978375fa&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__